import { infoClient } from '~/core/utils/clients/infoClient'
import type { AppointmentAnalysisState, AppointmentStatus, AppointmentType, TelemedState } from '~/features/Appointments/enums'
import type { AppointmentEdmIntegrationStatus } from '~/features/Appointments/enums'
import type { AppointmentClubState } from '~/features/Appointments/enums'

const RESOURCE = '/appointments/'

type AppointmentListItemDtoBody<T extends AppointmentType> = {
  id: number
  type: T
  title: string
  timedelta: number
  patientTimedelta: number | null
  datetimeVisit: DateTimeISO
  avatarPath: string
  isOnline: boolean
  currentStatus: Exclude<AppointmentStatus, AppointmentStatus.Absence>
  familyProfileUuid: string | null
  edmIntegration: AppointmentEdmIntegrationStatus
  /**
   * Число документов для подписи
   *
   * null, undefined - документы еще не сформированы
   * 0 - все документы подписаны
   * > 0 - число документов для подписи
   */
  edmDocumentForSignCount?: number | null
  clubState?: AppointmentClubState | null
}

export type AppointmentDoctorListItemDto = AppointmentListItemDtoBody<AppointmentType.Doctor> & {
  specialityName: string
}

export type AppointmentServiceListItemDto = AppointmentListItemDtoBody<AppointmentType.Service>

export type AppointmentTelemedListItemDto = AppointmentListItemDtoBody<AppointmentType.Telemed> & {
  specialityName: string
  telemedState: TelemedState
}

export type AppointmentAnalysisListItemDto = Omit<
  AppointmentListItemDtoBody<AppointmentType.Analysis>,
  'datetimeVisit' | 'patientTimedelta' | 'timedelta' | 'isOnline'
> & {
  lpuName: string
  analysisState: AppointmentAnalysisState
  expirationDate: DateISO
}

export type AppointmentsListItemDto = AppointmentDoctorListItemDto |
  AppointmentServiceListItemDto |
  AppointmentTelemedListItemDto |
  AppointmentAnalysisListItemDto

export type AppointmentsListDto = Array<AppointmentsListItemDto>

export default {
  get(status?: Exclude<AppointmentStatus, AppointmentStatus.Absence>, limit?: number) {
    return infoClient.get<AppointmentsListDto>(`${RESOURCE}v3/`, {
      params: { status, limit },
      camelize: true,
    })
  },
  getAppointmentsCount() {
    return infoClient.get<{ doctorAppointmentsCount: number, serviceAppointmentsCount: number }>(
      `${RESOURCE}v2/count/`,
      { camelize: true },
    )
  },
}
